// src/pages/Courses.js
import React from "react";

import CourseCard from "../components/cards";
import Footer from "../components/Footer";
import { useDynamicCSS } from "../hooks/DynamicCSSLoader";
// import { useNavigate } from "react-router-dom";

function Courses({ showFooter = true }) {
  useDynamicCSS("course");
  useDynamicCSS("cards");
  useDynamicCSS("popup");
  // const [expandedModules, setExpandedModules] = useState([]);
  // const navigate = useNavigate();

  // const toggleModule = (index) => {
  //   setExpandedModules((prevExpanded) =>
  //     prevExpanded.includes(index)
  //       ? prevExpanded.filter((i) => i !== index)
  //       : [...prevExpanded, index]
  //   );
  // };

  return (
    <>
      <div className="courses-page">
        <div className="page-header">
          <h1 className="page-title">🚀 Featured Courses</h1>
          <p className="page-subtitle">
            Master new skills with our expert-led courses
          </p>
        </div>

        <div className="courses-grid">
          <CourseCard
            image="https://img.freepik.com/premium-vector/vector-illustration-cute-green-python-coding-laptop_831490-4587.jpg"
            title="Module 1: Python Foundations"
            description="Master Python basics and dive into advanced topics like OOP, list comprehensions, and lambda functions for data applications."
            author="Aman Kasaudhan"
            role="Python Developer"
            videoUrl="https://www.youtube.com/embed/DRpts89ecPQ"
          />

          <CourseCard
            image="https://www.techslang.com/wp-content/uploads/2021/10/thinking-ai-humanoid-robot-analyzing-screen-mathematics-formula-science-e1634742458866.jpg"
            title="Module 2: Mathematics for ML"
            description="Cover linear algebra, calculus, and probability/statistics essential for machine learning foundations."
            author="Aman Kasaudhan"
            role="Mathematics Professor"
            videoUrl="https://www.youtube.com/embed/pkaSH23cjWI"
          />

          <CourseCard
            image="https://media.licdn.com/dms/image/v2/D4D12AQHY5lUTWzltLA/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1701542064078?e=2147483647&v=beta&t=LsVnNAZgOAPzoQhazX9dY_l5sUO40-DYjUntMF1JZwc"
            title="Module 3: Statistics for Data Science"
            description="Learn descriptive and inferential statistics, regression analysis, and ANOVA to support data-driven insights."
            author="Aman Kasaudhan"
            role="Data Analyst"
            videoUrl="https://www.youtube.com/embed/lqzEdcl70U4"
          />

          <CourseCard
            image="https://www.simplilearn.com/ice9/free_resources_article_thumb/machine_learning_terms.jpg"
            title="Module 4: Machine Learning Essentials"
            description="Explore supervised/unsupervised learning algorithms, model evaluation, and performance metrics like F1-score."
            author="Aman Kasaudhan"
            role="ML Engineer"
            videoUrl="https://www.youtube.com/embed/pkaSH23cjWI"
          />

          <CourseCard
            image="https://www.devprojournal.com/wp-content/uploads/2021/04/cloud-computing-data-696x392.jpg"
            title="Module 5: Databases and Cloud Computing"
            description="Master SQL, NoSQL databases, and cloud platforms for scalable data storage and processing solutions."
            author="Aman Kasaudhan"
            role="Cloud Architect"
            videoUrl="https://www.youtube.com/embed/F5nrhhgxjCY"
          />

          <CourseCard
            image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyhAVN1lexbzD4n7WyoNtpgxIZauHAAdGUyw&s"
            title="Module 6: Deep Learning and NLP"
            description="Build neural networks, understand deep learning architectures, and implement natural language processing models."
            author="Aman Kasaudhan"
            role="AI Researcher"
            videoUrl="https://www.youtube.com/embed/Opfn36hViTI"
          />

          <CourseCard
            image="https://cdn.sanity.io/images/i6kpkyc7/prod-dataset/224b07db9590c4f1bb7843bfa07d94f0c4836c32-2048x1152.jpg"
            title="Module 7: Transformers, GPT Models & RAG"
            description="Master modern AI architectures including transformer models, GPT implementations, and retrieval-augmented generation."
            author="Aman Kasaudhan"
            role="AI Specialist"
            videoUrl="https://www.youtube.com/embed/-Jbpgh9y7SY"
          />

          <CourseCard
            image="https://skaftenicki.github.io/dtu_mlops/figures/mlops_cycle.png"
            title="Module 8: MLOps and Model Deployment"
            description="Learn to deploy, monitor, and maintain machine learning models in production environments at scale."
            author="Aman Kasaudhan"
            role="DevOps Engineer"
            videoUrl="https://www.youtube.com/embed/gcx2vFk8uoM"
          />

          <CourseCard
            image="https://www.solulab.com/wp-content/uploads/2024/03/GenAI-Automation.jpg"
            title="Module 9: AI Automation Project"
            description="Leverage AI to automate real-world tasks by integrating machine learning, NLP, and APIs into a functional pipeline."
            author="Aman Kasaudhan"
            role="Senior AI Engineer"
            videoUrl="https://www.youtube.com/embed/H8U3V4BnpbU"
          />
        </div>
      </div>

      {showFooter && <Footer />}
    </>
  );
}

export default Courses;
